
import { Dialog, DialogContent, DialogFooter } from 'components/ui/dialog'
import { Textarea } from 'components/ui/textarea'
import { Button } from 'components/ui/button';
import { useAddInstructionToProject } from '../hooks/use-projects';
import { useState, useEffect } from 'react';

import { useToast } from "../../../hooks/use-toast";
import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';

// import { useTranslation } from 'react-i18next'

// interface FileItem {
//     id: string;
//     file: File;
//     name: string;
//     size: string;
//     type: string;
// }

function AddInstructionModal({ isFetchingProject, fetchedProject, isOpen, setIsOpen, projectId, refetchProject }: {
    isFetchingProject: boolean,
    fetchedProject: any,
    isOpen: boolean, setIsOpen: (isOpen: boolean) => void, projectId: string,
    refetchProject: () => void,
}) {
    const { toast } = useToast();
    const { t } = useTranslation();

    const { mutateAsync: addInstructionToProject, isPending } = useAddInstructionToProject(projectId);
    const [instruction, setInstruction] = useState('');

    console.log('isFetchingProject', isFetchingProject, "fetchedProject?.prompts", fetchedProject)

    // Update instruction when modal opens or prompts change
    useEffect(() => {
        if (isOpen && fetchedProject?.prompts?.length > 0 && !isFetchingProject) {
            const prompt = fetchedProject?.prompts?.find((prompt: any) => prompt.type === 'user');
            setInstruction(prompt?.content || '');
        }
    }, [isOpen, fetchedProject, isFetchingProject]);

    const handleAddInstruction = async () => {
        try {
            const response = await addInstructionToProject(instruction);
            // console.log('response', response);
            if (response?.prompts && response.prompts.length > 0) {
                toast({
                    title: t('INSTRUCTION_ADDED_SUCCESSFULLY'),
                    description: t('INSTRUCTION_DESCRIPTION_SUCCESSFULLY'),
                    variant: 'success',
                });
                setInstruction('');
                setIsOpen(false);
                await refetchProject();
            } else {
                toast({
                    title: t('FAILED'),
                    description: t('FAILED_TO_ADD_INSTRUCTION'),
                    variant: 'destructive',
                });
            }
        } catch (error) {
            console.error('Failed to add instruction:', error);
            toast({
                title: t('FAILED'),
                description: error instanceof Error ? error.message : t('FAILED_TO_ADD_INSTRUCTION'),
                variant: 'destructive',
            });
        }
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>

            <DialogContent className=" max-w-4xl h-[60vh] w-[calc(100%-2rem)]  sm:w-[calc(100%-3rem)] sm:max-w-[800px] p-4 flex flex-col" showOverlay={true} hideClose={true}>
                {isFetchingProject ? (
                    <div className="flex items-center justify-center h-full w-full" >
                        <Loader2 className="animate-spin" />
                    </div>
                ) : (
                    <div className='relative h-full'>

                        <h2 className="text-[16px] sm:text-[18px] font-light text-foreground leading-[24px] sm:leading-[28px]">
                            {t('INSTRUCTIONS')}
                        </h2>

                        <h5 className="text-sm font-normal mt-5 mb-2">
                            {t('HOW_CAN_EAGLEGPT_BEST_HELP_YOU_WITH_THIS_PROJECT')}
                        </h5>
                        <p className="text-muted-foreground text-sm font-light">
                            {t('YOU_CAN_ASK_EAGLEGPT')}

                        </p>
                        <Textarea className='focus:ring-token-text-primary min-h-64  border-heavy mt-4 mb-5 w-full grow resize-none overflow-x-clip overflow-y-auto rounded-lg border px-3 py-2 focus:ring-1 bg-transparent' placeholder={t('RESPOND_IN_SPANISH_REFERENCE')} value={instruction} onChange={(e) => setInstruction(e.target.value)} />




                        <DialogFooter className="flex flex-row justify-end space-x-2">
                            <Button variant="outline" onClick={() => {
                                setInstruction('');
                                setIsOpen(false);
                            }} disabled={isPending} className='w-24 outline-none'>
                                {t('CANCEL')}
                            </Button>
                            <Button onClick={() => { handleAddInstruction(); }} className='w-24 bg-primary' disabled={isPending && isFetchingProject}>
                                {(isPending || isFetchingProject) ? <Loader2 className="animate-spin" /> : t('SAVE')}
                            </Button>
                        </DialogFooter>


                    </div>
                )}
            </DialogContent>
        </Dialog >
    );
}
export default AddInstructionModal;